export const current = [
  {
    name: 'Wassim Alsindi, Ph.D.',
    avatar: require('./img/Wassim_Alsindi.jpg'),
    position: 'Technical Project Manager and Senior Researcher',
    positionDetail: 'Technology, Law, and Economic Policy',
    description: 'Wassim Alsindi engages with conceptual design and philosophy of token economies at BlockScience, in addition to writing and editorial responsibilities at publications like the MIT Computational Law Report. He is the founder and host of the 0x Salon, conducting experiments in post-disciplinary collective knowledge practices involving discourse, art and writing. Previously, Wassim co-founded MIT’s Cryptoeconomic Systems (CES) journal and conference series and developed novel characterisation approaches for cryptoassets and networks such as the regulatory epistemology project TokenSpace. Wassim holds a Ph.D. in Ultrafast Photophysics from the University of Nottingham, UK, alongside master\'s degrees in chemistry and finance.',
    socials: {
      twitter: '@wassimalsindi',
      medium: '',
      linkedin: '',
      email: 'wassim@block.science'
    }
  },
  {
    name: 'Eric Alston, J.D.',
    avatar: require('./img/Eric_Alston.jpg'),
    position: 'Senior Researcher',
    positionDetail: 'Constitutional Design',
    description: 'Eric Alston studies rules academically, and teaches business school students about them at the same time. He draws upon concepts and methodologies from institutional and organizational analysis and law and economics, and applies these to questions in constitutional design and digital governance.',
    socials: {
      twitter: '',
      medium: '',
      linkedin: 'eric-alston',
      email: ''
    }
  },
  {
    name: 'Ilan Ben-Meir',
    avatar: require('./img/Ilan_ben_meir.jpg'),
    position: 'Senior Lexical Engineer and Researcher',
    positionDetail: 'Media and Culture',
    description: 'Ilan Ben-Meir is a Ph.D. candidate in English at Brown University, where he studies post-digital textuality, metamodernism, and intersubjective time. He received his MPhil in Screen Media and Cultures from the University of Cambridge in 2014, and his BA in English at Yale in 2012. Before starting at Brown, he was a political reporter for BuzzFeed News.',
    socials: {
      twitter: '@ilanagain',
      medium: '',
      linkedin: 'ilan-ben-meir-a37a70a7',
      email: 'ilan@block.science'
    }
  },
  {
    name: 'Danilo Lessa Bernardineli',
    avatar: require('./img/danilo.jpg'),
    position: 'Senior Research Engineer',
    positionDetail: 'Computational Science',
    description: 'Danilo Lessa Bernardineli is an atmosphere physicist from Ariquemes, on the Amazon, and brings interdisciplinary data science knowledge and skills from several research and open-source projects which he took part in during his stay at the University of São Paulo. From web scraping to complex modeling, and always through a rigorous Bayesian statistics lens, Danilo is a firm believer in the power of science to bring resilience and adaptability to systems. He is excited to work with BlockScience to help usher in a new era of systemic and data-driven decision making to complex systems. His personal interests include ultra-endurance road cycling, and teaching out-of-the-box skills to others.',
    socials: {
      twitter: '@danilolessa',
      medium: '@danlessa',
      linkedin: 'danilo-lessa-bernardineli-56650a51',
      email: 'danilo@block.science'
    }
  },
  {
    name: 'Andrew Clark, Ph.D.',
    avatar: require('./img/andrew-clark.jpg'),
    position: 'Senior Research Engineer',
    positionDetail: 'Machine Learning and Economics',
    description: 'Andrew Clark is a data dconomist at BlockScience with a background in financial and technology auditing with a focus on building machine learning auditing systems. Andrew received a BS in Business Administration with a concentration in Accounting, Summa Cum Laude, from the University of Tennessee at Chattanooga, an Master in Data Science from Southern Methodist University, and is a PhD student in Economics at the University of Reading focusing on International Monetary Policy. He also holds the Certified Analytics Professional, American Statistical Association Graduate Statistician, and AWS Certified Solutions Architect - Associate certifications.',
    socials: {
      twitter: '@brassatc',
      medium: '',
      linkedin: 'andrew-clark-b326b767',
      email: 'andrew@block.science'
    }
  },
  {
    name: 'RJ Cordes',
    avatar: require('./img/anon.png'),
    position: 'Senior Research Engineer',
    positionDetail: 'Social Systems',
    description: 'RJ Cordes is a researcher and social systems engineer interested in memetics, knowledge and information management, and organizational psychology. He regularly contributes to and helps facilitate interdisciplinary teams, committees, and working groups across the public and private sectors addressing interorganizational information sharing, sensemaking, and decision-making in a wide variety of contexts, including public health, education, and food security. RJ spends his free time on hiking, carpentry, and applying enterprise-level knowledge management in odd places, such as exploring and cataloging patterns in music composition, narrative structure, wargaming, cookery, and coffee.',
    socials: {
      twitter: '',
      medium: '',
      linkedin: '',
      email: ''
    }
  },
  {
    name: 'Jeff Emmett',
    avatar: require('./img/Jeff_Emmett.jpg'),
    position: 'Communications and Researcher',
    positionDetail: '',
    description: 'Jeff Emmett is a researcher and technical writer at BlockScience. He has a background in electrical engineering from the University of Waterloo. He has been one of the early advocates for the establishment of safe and ethical Token Engineering in the web3 space.  Along with Michael Zargham & Griff Green, he co-founded the Commons Stack to build out a toolkit of modular components that can be used for polycentric governance of DAO ecosystems. He is involved in multiple open research initiatives into novel resource allocation patterns like bonding curves and conviction voting that could facilitate a future of data-driven algorithmic policy and computer-aided governance.',
    socials: {
      twitter: '@jeffemmett',
      medium: '@jeffemmett',
      linkedin: 'jeff-emmett-05268139',
      email: 'jeff@block.science'
    }
  },
  {
    name: 'Dan Furfari',
    avatar: require('./img/dan_furfari.jpg'),
    position: 'Program and Operations Manager',
    positionDetail: '',
    description: 'Dan Furfari is the Program and Operations Manager for BlockScience. "Furf" earned a Chemical Engineering degree from the University of Notre Dame, and has spent the last 20 years managing projects for an industrial gas company ranging from hydrogen gas pipelines to large-scale energy-from-waste facilities to air separation units plants. He also worked as the Resource and Workload planning manager for the cold box design team which executes the detailed engineering and design for the company\'s core technologies. Originally from Colorado, he enjoys biking, rock climbing, ultimate frisbee, and going on adventures with his family.',
    socials: {
      twitter: '@furf88',
      medium: '',
      linkedin: 'furf88',
      email: 'furf@block.science'
    }
  },
  {
    name: 'Jakob Hackel, Ph.D.',
    avatar: require('./img/Jakob_Hackel.jpg'),
    position: 'Technical Project Manager and Researcher',
    positionDetail: 'Economics',
    description: 'Jakob Hackel is a technical project manager and researcher focussing on socio-technical systems. He has recently defended his PhD thesis at the Research Institute for Cryptoeconomics, part of the Vienna University of Economics and Business (WU). Prior to his PhD, he earned a Master in Digital Currencies at the University of Nicosia. In his four years at the institute he has worked on projects with start-ups, governments, central banks and large international organizations such as the World Bank Group. He continues to hold lectures at the University, presents research at conferences and takes part in hackathons.',
    socials: {
      twitter: '',
      medium: '',
      linkedin: 'jakob-hackel-0a5793171',
      email: 'jhackel@block.science'
    }
  },
  {
    name: 'Peter Hacker',
    avatar: require('./img/peter_hacker.png'),
    position: 'Technical Project Manager and Research Engineer',
    positionDetail: '',
    description: 'Peter Hacker works at BlockScience supporting the publication pipeline and managing evergreen content flow. He has a degree in Economics and Mathematics from Northeastern University, and spent 4 years working in data analytics and business strategy for an international eCommerce company. He is passionate about advancing the field of token engineering through #OpenScience, and has been an active contributor across a number of TE community organizations - cadCAD, Token Engineering Commons, Token Engineering Academy - running education programs & sharing research / resources with fellow aspiring token engineers.',
    socials: {
      twitter: '@phacker_3',
      medium: '@phacker3',
      linkedin: 'peter-hacker-890b85b7',
      email: 'peter@block.science'
    }
  },
  {
    name: 'Hash',
    avatar: require('./img/anon.png'),
    position: 'Communications and Researcher',
    positionDetail: '',
    description: 'Hash supports the communications team and performs research support functions.',
    socials: {
      twitter: '@Coad1024',
      medium: '',
      linkedin: '',
      email: ''
    }
  },
  {
    name: 'Nick Hirannet P.E., PMP',
    avatar: require('./img/nick_hirannet.jpg'),
    position: 'Chief Operating Officer',
    positionDetail: '',
    description: 'Nick Hirannet spent 10 years working as a mechanical engineer and project manager for the U.S. Army Corps of Engineers, Marine Design Center. He is a licensed Professional Engineer and Project Management Professional. He has managed projects for a variety of Government agencies including the U.S. Army, U.S. Coast Guard, National Park Service, and NASA. Outside of his professional career, Nick is an accomplished ultimate frisbee player, having served as captain for two semi-professional league championship teams.',
    socials: {
      twitter: '@hirannet7',
      medium: '@nickhirannet',
      linkedin: 'nick-hirannet-0b295416a',
      email: 'nick@block.science'
    }
  },
  {
    name: 'Sarah Hirannet',
    avatar: require('./img/sarah-johnson.jpg'),
    position: 'Controller / Office Manager',
    positionDetail: '',
    description: "Sarah Hirannet is the Controller and Office Manager at BlockScience. She has a bachelor's degree in International Studies and a master's degree in education. She draws from her prior experience overseeing admissions and facilitating day to day operations at a charter school.  Sarah brings organization, efficiency, and initiative to BlockScience.",
    socials: {
      twitter: '',
      medium: '',
      linkedin: '',
      email: 'sarah@block.science'
    }
  },
  {
    name: 'Joshua Jodesty',
    avatar: require('./img/joshua_jodesty.jpg'),
    position: 'Senior Research Engineer',
    positionDetail: '',
    description: 'Joshua Jodesty is a data & software engineer who implemented scalable, parallelized, concurrent, and distributed stochastic simulation software for digital twin implementations and sociotechnical system design of the decentralized web. He also implemented machine learning enabled big data processing solutions for viewership forecasting in AdTech, a cross-disciplinary data product for supply chain management, and conducted machine learning research enabling the prediction of student performance in online courses. Joshua enjoys trying new cuisine, applying research, emerging technologies, and implementing scalable distributed systems on cloud platforms to solve complex problems with cross-disciplinary teams.',
    socials: {
      twitter: '@JEJodesty',
      medium: '@jejodesty',
      linkedin: 'jejodesty',
      email: 'joshua@block.science'
    }
  },
  {
    name: 'Lila Langsford',
    avatar: require('./img/Lila_A_Langsford.jpg'),
    position: 'Communications',
    positionDetail: '',
    description: 'Lila Langsford is a seasoned marketing professional with over 15 years of experience leading successful campaigns across diverse business verticals. Leveraging her expertise in content creation, digital marketing, and SEO, Lila enjoys helping to drive growth and improve processes as a member of the BlockScience Communications team. With a bachelor\'s degree in Business Marketing and a master\'s degree in English Language Arts, she brings a unique blend of creativity and analytical skills to her work. Lila\'s contributions to the field have been recognized by publications such as Palm Springs Life and various trade publications. She is passionate about marketing due to its constantly evolving nature, which presents her with new challenges and opportunities to learn and grow every day.',
    socials: {
      twitter: '@Leee_lah',
      medium: '',
      linkedin: '',
      email: ''
    }
  },
  {
    name: 'Zhiwei Li, Ph.D.',
    avatar: require('./img/Zhiwei.jpg'),
    position: 'Research Engineer',
    positionDetail: '',
    description: 'Zhiwei Li has a background of neuroscience and computational cognitive science, where quantitative modeling are used to understand people\'s cognition and behavior. She holds a Ph.D. of neuroscience from New York University, with the thesis on probabilistic modeling on people\'s subjective judgement. Zhiwei is interested in the intersection of system modeling and behavioral science. She\'s also initiated many interdisciplinary projects to compare the cognitive styles of different research fields, the recent one being the podcast called Research Journey Initiative. When she\'s not in front of the computer Zhiwei geeks out on somatic awareness practices (esp. Feldenkrais method), holistic health, writing, rock climbing and jamming with her ukulele.',
    socials: {
      twitter: '',
      medium: '',
      linkedin: 'zhiwei-li-12b17098/',
      email: 'zhiwei@block.science'
    }
  },
  {
    name: 'Sean McOwen',
    avatar: require('./img/Sean_McOwen.png'),
    position: 'Senior Research Engineer',
    positionDetail: 'Quant',
    description: 'Sean McOwen is a senior research engineer at BlockScience. He previously worked in a quantitative hedge fund startup where he was able to wear many hats as a researcher, data scientist, and developer, depending on the day. He graduated from Boston College with a double major in Finance and Economics, received a Master of Analytics from Georgia Tech, and is finishing a Master in Applied Mathematics at Columbia. He also created and runs FinanceAndPython.com which is his passion project with the goal of providing free courses on utilizing python for finance and economics-based applications.',
    socials: {
      twitter: '',
      medium: '',
      linkedin: 'sean-mcowen-cfa-caia-frm-b8962b46',
      email: 'sean@block.science'
    }
  },
  {
    name: 'Rohan Mehta',
    avatar: require('./img/Rohan_Mehta.jpg'),
    position: 'Research Engineer',
    positionDetail: '',
    description: 'Rohan Mehta is a researcher and data scientist specializing in complex systems modeling techniques. He holds an MSc (Hons.) in Physics and a BE (Hons.) in Electronics and Instrumentation. Rohan began his career at the Tata Institute of Fundamental Research, where he worked in the FOTON labs focusing on simulations of metamaterials interactions under Terahertz Spectroscopy. Professionally, Rohan has worked as a data scientist at Kinnect, Token Engineering Academy, and the Bonding Curve Research Group. He is particularly fascinated by how intelligent systems emerge from simple building blocks, whether in biology, social sciences, or physics. This passion drives much of his research and professional endeavors. Rohan enjoys traveling and capturing the unique stories of people he meets over the chessboard.',
    socials: {
      twitter: '',
      medium: '',
      linkedin: 'rohan-mehta-5b086b190',
      email: ''
    }
  },
  {
    name: 'Luke Miller',
    avatar: require('./img/Luke_Miller.jpg'),
    position: 'Research Engineer',
    positionDetail: '',
    description: 'Luke Miller is a researcher and software engineer working on knowledge organization infrastructure. He received degrees in Computer Science and Chinese from the University of Notre Dame. Over the past few years Luke has worked with both BlockScience and Metagov on a wide range of projects involving building digital self-governance tools, modeling socio-technical systems, and challenging implicit power structures found in the digital world.',
    socials: {
      twitter: '',
      medium: '',
      linkedin: 'lvmiller',
      email: ''
    }
  },
  {
    name: 'Kelsie Nabben, Ph.D.',
    avatar: require('./img/kelsie_nabben.png'),
    position: 'Senior Social Scientist',
    positionDetail: 'Digital Ethnography',
    description: 'Kelsie Nabben is a qualitative researcher in decentralised technology communities. She is particularly interested in the human outcomes of digital infrastructure, resilience, blockchain community culture, and algorithmic governance. Kelsie is a recipient of a PhD scholarship at the RMIT University Centre of Excellence for Automated Decision-Making & Society, and a researcher in the Blockchain Innovation Hub and Digital Ethnography Research Centre. She has advised government on cybersecurity and DAOs also a contributor to open-source research network Metagov.',
    socials: {
      twitter: '@kelsiemvn',
      medium: '@kelsienabben',
      linkedin: 'kelsien',
      email: 'kelsie@block.science'
    }
  },
  {
    name: 'Heather Ordway',
    avatar: require('./img/Heather_Ordway.jpg'),
    position: 'People Ops / Internal Project Manager',
    positionDetail: '',
    description: 'Heather Ordway is the People Operations Manager for BlockScience. She has a master\'s degree in secondary education and has 13 years of experience in curriculum design, case management, and teaching. She enjoys gardening, travel, and rock climbing. ',
    socials: {
      twitter: '',
      medium: '',
      linkedin: '',
      email: 'heather@block.science'
    }
  },
  {
    name: 'Orion Reed',
    avatar: require('./img/orion_reed.jpg'),
    position: 'Senior Research Engineer',
    positionDetail: 'Knowledge Systems',
    description: 'Orion Reed is a researcher in knowledge representation and socio-technical systems. His interests include the application of cybernetics to software; participatory digital systems; and human-computer interaction. He is currently developing systems-theoretic approaches to digital representation infrastructure to support the development of knowledge commons, and to improve the infrastructure which communities rely on for coordination, communication, and collective reasoning.',
    socials: {
      twitter: '@OrionReedOne',
      medium: '',
      linkedin: '',
      email: 'orion@block.science'
    }
  },
  {
    name: 'Carolina Riascos Álvarez, Ph.D.',
    avatar: require('./img/Carolina_Riascos.png'),
    position: 'Research Engineer',
    positionDetail: '',
    description: 'Carolina Riascos Álvarez is an Industrial & Systems Engineer whose work leverages the synergy between operations and technology innovation to deliver informed policies into real-world systems. She holds a Ph.D. in Industrial Engineering from the University of Toronto (Canada) and a Master\'s degree in Systems Engineering from Universidad Autónoma de Nuevo León (Mexico). Her research lies at the intersection of mathematical and dynamic programming, game theory, and computer science. Carolina has published work on market design and robust optimization and has worked in the logistics and automotive industries.',
    socials: {
      twitter: '',
      medium: '',
      linkedin: 'carolina-riascos-álvarez',
      email: ''
    }
  },
  {
    name: 'Jamsheed Shorish, Ph.D.',
    avatar: require('./img/jamsheed.jpg'),
    position: 'Senior Research Engineer',
    positionDetail: 'Mathematical & Computational Economics',
    description: 'Jamsheed Shorish is the CEO and Founder of Shorish Research (Belgium), which provides consulting services for Computational Business and disruptive financial technologies. He holds Ph.D. and Master’s degrees in Economics from the Tepper School of Business, Carnegie Mellon University (USA), and has over 20 years of experience in academic teaching and research in computational and financial economics. His current research includes work on distributed ledger technologies (DLTs) and the valuation of cryptographically-supported DLT tokens. He also has published work on asset pricing, market games, dynamic optimization problems, and the study of socio-economic network formation and structure. Dr. Shorish is an Honorary Associate Professor at the Australian National University (Australia), and is a Visiting Researcher at the Research Institute for Cryptoeconomics at the Vienna University of Economics and Business (Austria).',
    socials: {
      twitter: '@jshorish',
      medium: '',
      linkedin: 'jshorish',
      email: 'jamsheed@shorishresearch.com'
    }
  },
  {
    name: 'David Sisson, Ph.D.',
    avatar: require('./img/David_Sisson.jpg'),
    position: 'Senior Research Engineer',
    positionDetail: 'Platforms',
    description: 'David Sisson has extensive experience designing and developing commercial software systems. Most recently he built and led Data Engineering and Data Science at an Ad Tech firm during their transition from a service-oriented business to platform provider. He has been a full product life cycle developer, and he has built teams necessary to scale these processes. He has experience building automated, data-driven, general business systems and data-acquisition/analysis applications in scientific and engineering settings. His tech career is informed by a Ph.D. in Neurophysiology and nine years of research experience in academic and pharmaceutical settings with a focus on using computational neuroscience to bridge micro (molecular and cellular) and macro (behavioral).',
    socials: {
      twitter: '',
      medium: '',
      linkedin: 'david-f-sisson',
      email: 'david@block.science'
    }
  },
  {
    name: 'Joshua Stafford',
    avatar: require('./img/Joshua_Stafford.jpg'),
    position: 'Research Engineer',
    positionDetail: '',
    description: 'Joshua Stafford has over 15 years of work experience building out analytics solutions. He has worked with complex Big Data, NLP, Monte Carlo, Python, Machine Learning and Spark-based analytical solutions. For the past 4 years he has served as Director of Analytics at JS Business Intelligence, LLC. He spent 9 years at Booz Allen Hamilton, creating systems for a variety of DoD clients and 3 years as a Data Analysis Manager at Capital One. He has extensive experience in software development and agile methodologies developing software solutions in a variety of languages with a variety of database backends.',
    socials: {
      twitter: '',
      medium: '',
      linkedin: 'josh-stafford',
      email: 'stafford@block.science'
    }
  },
  {
    name: 'Sayer Tindall',
    avatar: require('./img/sayer_tindall.jpg'),
    position: 'Technical Project Manager and Research Engineer',
    positionDetail: '',
    description: 'Sayer Tindall is a research engineer and project coordinator at BlockScience. He began his career as a nuclear engineer, working with the Navy and the Department of Energy. He then founded two companies dedicated to developing alternative economic systems using mutual credit — a system where businesses extend credit to each other without needing traditional currency. These ventures targeted emerging markets across Africa, North America, and South America. He is excited to combine his background in software engineering and system design to continue to innovate and implement advanced economic models and solutions.',
    socials: {
      twitter: '',
      medium: '',
      linkedin: 'sayertindall',
      email: ''
    }
  },
  {
    name: 'Christine Vandevoorde',
    avatar: require('./img/Christine_Vandevoorde.jpg'),
    position: 'Technical Project Manager and Research Engineer',
    positionDetail: '',
    description: 'Christine Vandevoorde is a Research Engineer and Technical Project Manager at BlockScience with an interest in collective intelligence and cyber-physical systems as public infrastructure. She holds a B.S. in Civil Engineering from UC Berkeley and an Master in Applied Urban Science and Informatics (Data Science for Cities) from NYU. Previously, she co-founded a startup focused on collaborative record keeping systems in DAOs and has worked across startups, academia, and the public sector. In her free time, she enjoys catching live jazz shows with friends, playing piano, and taking photos of flowers.',
    socials: {
      twitter: '',
      medium: '',
      linkedin: 'sayertindall',
      email: ''
    }
  },
  {
    name: 'Michael Zargham, Ph.D.',
    avatar: require('./img/michael_zargham.jpg'),
    position: 'Founder, CEO, Chief Engineer',
    positionDetail: '',
    description: 'Michael Zargham is the founder and CEO of BlockScience. Dr. Zargham holds a Ph.D. in systems engineering from the University of Pennsylvania where he studied optimization and control of decentralized networks. His earliest work on peer-to-peer effects in business decision making was developing algorithms to reverse engineer the word of mouth effect in enterprise software licensing decisions in 2005. In the intervening years, Dr. Zargham has designed data driven decision systems and built a data science team for a Media Technology firm, worked on the mathematical specifications of blockchain enabled software systems with a focus on observability and controllability of the information state of the networks.',
    socials: {
      twitter: '@mZargham',
      medium: '@michaelzargham',
      linkedin: 'mczargham',
      email: 'zargham@block.science'
    }
  },
  {
    name: 'Jessica Zartler',
    avatar: require('./img/Jessica_Zartler.jpg'),
    position: 'Communications and Researcher',
    positionDetail: '',
    description: 'Jessica Zartler is an award-winning journalist and token engineering researcher, studying and writing about regenerative economics, computer-aided governance, complex systems, algorithmic policy design, narratives and memetics. She lends her narrative experience to support BlockScience research and communications. She is also the Ecosystem Development and Special Project Director for the Commons Stack and a founding Steward of the Token Engineering Commons. Jessica is passionate about Conscious Decentralization and the resurgence of the commons movement, yogic philosophy and harnessing new economic mechanisms and socio-technical systems to heal people and the planet.',
    socials: {
      twitter: '@jessicazartler',
      medium: '@jessicazartler',
      linkedin: 'jessicazartler',
      email: 'jessica@block.science'
    }
  }]
export const advisors = [
  {
    name: 'Matt Barlin',
    avatar: require('./img/matt_barlin.jpg'),
    position: 'Systems Engineering',
    description: 'Matt Barlin is the Chief Technology Officer at Valence Digital, Inc. He has engineered data science solutions serving blockchain, transportation, healthcare, and energy fields. From model testing a mine-sweeping hovercraft to running a digital electronics laboratory, Matthew’s career experiences have revolved around data analysis. Matthew holds a Master’s degree (SM) from MIT and Bachelor’s degree (BS) from Webb Institute. ',
    socials: {
      twitter: '@mattbarlin',
      medium: '@mbarlin_42335',
      linkedin: 'matthew-barlin',
      email: ''
    }
  },
  {
    name: 'Amber Case',
    avatar: require('./img/amber_case.png'),
    position: 'Strategy and Research',
    description: 'Amber Case is a leading expert on the intersection of humans and technology, exploring how our digital landscape shapes culture and society. She has written four books, including the influential "Calm Technology" and "A Kids Book About Technology." Case\'s contributions to the field have earned her significant recognition. She was listed in Inc. Magazine\'s 30 under 30, Fast Company\'s Most Influential Women in Technology, and named a National Geographic Emerging Explorer. Her innovative work received the Claude Shannon Innovation Award from Bell Labs. Her research includes fellowships at MIT\'s Center for Civic Media and Harvard\'s Berkman Klein Center for Internet & Society. In 2021, she was selected as a Mozilla Fellow. Case co-founded Geoloqi, a location-based software company later acquired by Esri. She now leads The Calm Tech Institute, developing standards for harmonious human-technology interactions that enhance our daily lives. Case is a Research Director at the Metagovernance Project, focusing on design, governance, and AI issues. Her work continues to shape the future of human-centered technology and its ethical implementation in society.',
    socials: {
      twitter: '@caseorganic',
      medium: '@caseorganic',
      linkedin: 'caseorganic',
      email: 'case@calmtech.institute'
    }
  },
  {
    name: 'Gregory Johnson, CFP',
    avatar: require('./img/Greg_Rubicon.jpg'),
    position: 'Strategy and Business Development',
    description: 'Greg Johnson has been a CEO and executive at Fortune 500 and start-up enterprises in the financial services and digital asset industries at American Express, Ameriprise Financial and Rubicon Digital Assets. Additionally, he is an NYU professor and serves on the NYU School of Professional Studies advisory board. A serial mentor and advisor to multiple fintech and Web3 start-up ventures, Greg is also a respected thought leader at the Atlantic Council, the Bretton Woods Committee and the Digital Dollar Project advisory board. He earned his undergraduate degree from The American University Kogod School of Business, Washington D.C. and an MBA from Emory University Goizueta Business School.',
    socials: {
      twitter: '',
      medium: '',
      linkedin: '',
      email: ''
    }
  },
  {
    name: 'Markus Koch',
    avatar: require('./img/markus_koch.jpg'),
    position: 'Research',
    description: 'Markus Koch is a control systems engineer by education, with over 20 years of experience in a broad range of areas covering system modeling and simulation, mechanism design, KPI formulation, data science and machine learning - both in the private and public sectors. Markus was part of a team of independent researchers and contributors of the blockchain space between 2013 and 2017, when he joined BlockScience as Lead Research Engineer. In 2020 Markus took on a role at Balancer Labs, where he works on the design of system components and promotes a data driven approach to protocol governance. He remains affiliated with BlockScience as a Research Advisor.',
    socials: {
      twitter: '@markusbkoch',
      medium: '@markusbkoch',
      linkedin: 'markusbkoch',
      email: 'markus@block.science'
    }
  },
  {
    name: 'Victor M. Preciado, Ph.D.',
    avatar: require('./img/victor_m_preciado.jpg'),
    position: 'Complex Systems Engineering',
    description: 'Victor M. Preciado is an Associate Professor of Electrical and Systems Engineering at the University of Pennsylvania, where he is affiliated with the Networked & Social Systems Engineering program, the Warren Center for Network & Data Sciences, and the Applied Math and Computational Science program. Victor received a PhD degree in Electrical Engineering and Computer Science from the Massachusetts Institute of Technology, and has been a visiting scientist at UC Berkeley and Santa Fe Institute. He is a recipient of the 2017 National Science Foundation CAREER Award. His primary research interests are modeling, analysis, and control of complex networked systems and engineering infrastructures, with applications in social networks, technological infrastructure, and biological systems. Since critical societal functions are increasingly dependent on complex networks, it is important to acquire a deeper understanding of the relationship between the structure and the dynamics of these systems.',
    socials: {
      twitter: '',
      medium: '',
      linkedin: 'victormp',
      email: 'preciado@seas.upenn.edu'
    }
  },
  {
    name: 'Antonio Reyes',
    avatar: require('./img/antonio_reyes.jpg'),
    position: 'Corporate Relations',
    description: 'Antonio Reyes has more than 30 years of experience in executive positions and founder roles in media, technology, education and not for profit entities. As Co-Founder and CEO of IGM Global Inc., Antonio\'s team developed an on-line B2B education media portal that provided C suite executives guidance regarding the impact of exponential technology. IGM Global served multinationals including LG and Doosan. As Co-Founder and CEO of Excelorators, Inc., he partnered with faculty at leading universities, and delivered training programs in the fields of Finance, Management and Risk Management for executives on the campuses of Harvard, Stanford, West Point, Wharton and MIT. As Co-Director of the Breakthrough Program in South Florida, he managed a team of 65 volunteer faculty. This non-profit delivered academic enrichment programs to nearly 600 students in high risk environments. As Founder of Startowers Inc., Antonio aggregated existing radio and television towers and sublet these to serve as co-location sites for wireless applications. The company executed master leases with a wide variety of companies including AT&T and Sprint. As Director of Latin American Operations for the CBN/Family Channel Network, he galvanized the interests of business, government, and broadcast companies in order to effectively execute diverse media strategies in 18 countries.',
    socials: {
      twitter: '',
      medium: '@antonioreyes',
      linkedin: 'antonio-reyes-870b7052',
      email: 'antonio@block.science '
    }
  },
  {
    name: 'Shermin Voshmgir, Ph.D.',
    avatar: require('./img/shermin-voshmgir.jpg'),
    position: 'Economics',
    description: 'Shermin Voshmgir is the author of the book Token Economy. She is the founder of BlockchainHub in Berlin and the co-founder of the Research Institute for Cryptoeconomics at the Vienna University of Economics. In the past, she was a curator of TheDAO (Decentralized Investment Fund), an advisor to Jolocom (Web3 Identity), Wunder (Tokenized Art) and the Estonian E-residency program. Shermin did her PhD in Information Systems Management at the Vienna University of Economics. Furthermore, she studied film and drama in Madrid. Her past work experience ranges from internet start-ups, IT consulting & filmmaking. She is Austrian, with Iranian roots, and lives between Vienna and Berlin.',
    socials: {
      twitter: '@sherminvo',
      medium: '@sherminvoshmgir',
      linkedin: 'sherminvoshmgir',
      email: 'voshmgir@wu.ac.at'
    }
  },
  {
    name: 'Stephen Zargham',
    avatar: require('./img/stephen_zargham.jpg'),
    position: 'Public Infrastructure',
    positionDetail: '',
    description: 'Steve Zargham brings decades of experience developing and deploying socio-technical system solutions meeting the business needs of the NYS Department of Transportation in delivering a capital construction program in excess of one billion dollars a year.  His public-sector experience balancing the wants and needs of diverse stakeholder groups provides a unique perspective on systems, incentives and human behavior.  A licensed Professional Engineer in NY, with Bachelor and Master of Science degrees in Civil Engineering from Rensselaer Polytechnic Institute, Steve applies his training and experience to producing sustainable solutions to important problems. ',
    socials: {
      twitter: '',
      medium: '',
      linkedin: '',
      email: 'steve@block.science'
    }
  }]
export const alumni = [
  {
    name: 'Chris Frazier',
    avatar: require('./img/Chris_Frazier.jpg'),
    position: 'Co-founder & CEO at BlockScience Labs',
    description: 'Former Project Manager at BlockScience',
    socials: {
      twitter: '',
      medium: '',
      linkedin: 'chris-frazier',
      email: 'chris@blocksciencelabs.com'
    }
  },
  {
    name: 'Harry Goodnight',
    avatar: require('./img/harry_goodnight.jpg'),
    position: 'COO at Enigma Data Inc',
    description: 'Former Executive Advisor at BlockScience',
    socials: {
      twitter: '',
      medium: '',
      linkedin: 'harry-goodnight-149110',
      email: ''
    }
  },
  {
    name: 'Marek Laskowski, Ph.D.',
    avatar: require('./img/marek.jpg'),
    position: 'OpenDefi',
    description: 'Former Senior Research Engineer at BlockScience',
    socials: {
      twitter: '@RegularMarek',
      medium: '',
      linkedin: 'laskowskimarek',
      email: 'marek@block.science'
    }
  },
  {
    name: 'Fernando Martinelli',
    avatar: require('./img/fernando_martinelli.jpg'),
    position: 'Co-founder & CEO at Balancer Labs',
    description: 'Former Researcher at BlockScience',
    socials: {
      twitter: '@fcmartinelli',
      medium: '',
      linkedin: '',
      email: ''
    }
  },
  {
    name: 'Matt Stephenson, Ph.D.',
    avatar: require('./img/matt_stephenson.jpg'),
    position: 'Head of Cryptoeconomics at Pantera Capital',
    description: 'Former Senior Research Engineer at BlockScience',
    socials: {
      twitter: '@stephensonhmatt',
      medium: '',
      linkedin: '',
      email: ''
    }
  },
  {
    name: 'ZX Zhang',
    avatar: require('./img/zixuan_zhang.jpg'),
    position: 'CryptoEconLab Lead at Protocol Labs',
    description: 'Former Researcher at BlockScience',
    socials: {
      twitter: '@zixuanzh',
      medium: '',
      linkedin: '',
      email: ''
    }
  }]
